module.exports = __webpack_public_path__ + "static/img/jjc_today_best2.67947d0d.png";